function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) =>
/*#__PURE__*/
React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props),
/*#__PURE__*/
React.createElement("path", {
  d: "M512 256c0 141-115 256-256 256S0 397 0 256 115 0 256 0s256 115 256 256zm0 0l-255 40h107c16 0 28-13 28-29 0-15-12-28-28-28h-94l-46-114c-6-14-22-21-37-15-14 6-21 22-15 37l50 125c2 9 8 17 16 21 6 3 12 4 19 3zm0 0"
})));